import { Box, useMediaQuery } from "native-base";
import React from "react";

const MemberContentArea = ({ children, marginTop }) => {
	const isDesktopOrLaptop = useMediaQuery({ minWidth: 960 });

	return (
		<Box
			// bg="#fff"
			padding={isDesktopOrLaptop[0] ? "20px" : 1}
			margin={isDesktopOrLaptop[0] ? "30px" : "1px"}
			borderRadius="5px"
			marginBottom="20px"
			marginTop={marginTop || 0}
			flex={1}
		>
			{children}
		</Box>
	);
};

export default MemberContentArea;
